import React, {useContext, useEffect } from 'react'
import { Button } from '@material-ui/core';
import moment from 'moment'
import downArrow from '../images/down.png'
import sideArrow from '../images/side.png'
import { ContextProvider } from '../globalContextProvider';

const ShowTimePeriod = ({ startDateTimeFilter, endDateTimeFilter, setShowTiles, showTiles, style }) => {
    const { setResetHeight } = useContext(ContextProvider);
    const updateTiles = () => {
        setShowTiles((prev) => !prev)
        setResetHeight((prev) => !prev)
    }

    useEffect(() =>{
        setResetHeight((prev) => !prev)
    },[]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10, ...style }}>
            <div style={{ color: "#8097B1", fontSize: 12 }}>
                Showing Results for:{" "}
                {startDateTimeFilter && endDateTimeFilter ?
                    (`${moment(startDateTimeFilter).format("MMM Do, YYYY hh:mm a")} - ${moment(endDateTimeFilter).format("MMM Do, YYYY hh:mm a")}`)
                    :
                    (`${moment().format("MMM Do, YYYY")} 12:00 AM - 11:59 PM`)}
            </div>
          {setShowTiles &&  <Button style={{ minWidth: "80px", background: "none", border: "none", cursor: "pointer", backgroundColor: "#109CF11A", color: "#5E8DD3", padding: "1px 12px", borderRadius: 2, fontSize: 9, textTransform:"none", fontWeight:"normal"}} onClick={updateTiles}><p style={{lineHeight: 0, marginRight: 5}}>{showTiles ? "Collapse" : "Show Tiles"}</p>
            <img src={showTiles ? downArrow : sideArrow} alt='arrow' />
            </Button>}
        </div>
    )
}

export default ShowTimePeriod